<!-- IanFeedbackContent.vue -->
<template>
  <section
    class="flex flex-col items-center justify-center w-full h-[90vh] px-4 bg-transparent overflow-auto"
  >
    <!-- Profile Section -->
    <div class="profile-section flex flex-col items-center text-center">
      <img
        src="@/assets/img/ian.jpg"
        alt="IAN S. SOMOSOT"
        class="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full border-4 border-gray-300 mb-4 object-cover"
      />
      <h1 class="text-lg sm:text-xl md:text-2xl font-bold text-white">
        IAN S. SOMOSOT
      </h1>
      <h2 class="text-sm sm:text-base md:text-lg text-white mb-5">
        Associate Professor II
      </h2>
    </div>

    <!-- Text + Image Section -->
    <div
      class="flex flex-col-reverse xl:flex-row items-center xl:items-stretch justify-center gap-6 xl:gap-10 mt-6 md:mt-8 w-full max-w-6xl"
    >
      <!-- Text Section -->
      <div class="flex-1 bg-transparent flex items-start justify-center">
        <div class="space-y-4">
          <p
            class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
          >
            Since 2016, I've been a fund manager here at the College, and I
            truly experienced the time when we had to print a lot of paper,
            especially when creating the PPMP (Project Procurement Management
            Plan) and PR (Purchase Request). Those documents often went back and
            forth multiple times due to numerous corrections.
          </p>
          <p
            class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
          >
            However, when the PMS (Procurement Management System) was introduced
            to the College, it was a great help. As one of the fund managers at
            DNSC, I always say that one of my favorite systems is the FRMS (Fund
            and Requisition Management System), formerly known as the
            Procurement Management System.
          </p>
        </div>
      </div>

      <!-- Image Section -->
      <div class="flex-1 flex justify-center items-stretch">
        <img
          src="@/assets/img/ian-1.jpg"
          alt="IAN S. SOMOSOT"
          class="w-full md:w-[500px] md:h-[390px] lg:h-[340px] rounded-2xl border-2 border-gray-300 object-cover shadow-lg"
        />
      </div>
    </div>

    <!-- Additional Paragraphs -->
    <div class="flex flex-col space-y-4 mt-2 md:mt-4 lg:mt-4 max-w-4xl">
      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        The convenience that this system offers is truly amazing, especially
        when it comes to preparing the PPMP and PR. Now, I can monitor fund
        balances in real-time. The number of mistakes has significantly
        decreased compared to the time before the PMS.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-semibold leading-relaxed"
      >
        My Experience Before and After the System
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        I vividly remember those days of manually consolidating requests. We had
        to physically verify every line item, recalculate budgets by hand, and
        chase down signatures across departments. It wasn’t just about printing
        — it was the fear that a small manual error could lead to major
        financial issues later. The time wasted correcting minor typos or
        misallocations was incredible.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        Now, with the FRMS, the process is streamlined. The system essentially
        acts as a powerful assistant:
      </p>

      <ul
        class="list-disc list-inside space-y-2 text-white text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed text-justify"
      >
        <li>It performs calculations automatically, minimizing human error.</li>
        <li>
          It alerts us to budget limits immediately, improving financial
          planning.
        </li>
        <li>
          All data is centralized, making report generation and procurement
          tracking much faster.
        </li>
      </ul>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        It has truly made our work as fund managers less about juggling paper
        and more about strategic financial management. The system didn’t just
        digitize a process—it professionalized our entire workflow.
      </p>
    </div>

    <!-- Close Button -->
    <button
      @click="$emit('close')"
      class="mt-5 px-8 py-3 bg-white/20 backdrop-blur-md text-white font-semibold rounded-full border border-white/40 shadow-lg hover:bg-red-600 hover:text-white hover:border-red-600 transition duration-300 ease-in-out"
    >
      Close
    </button>
  </section>
</template>

<script>
export default {
  name: "IanFeedbackContent",
};
</script>

<style scoped>
/* ✅ Custom responsive spacing for the profile section */
.profile-section {
  margin-top: 90rem; /* default for mobile */
}

@media (min-width: 640px) {
  /* sm screens (small tablets, large phones) */
  .profile-section {
    margin-top: 8rem;
  }
}

@media (min-width: 768px) {
  /* md screens (tablets) */
  .profile-section {
    margin-top: 60rem;
  }
}

@media (min-width: 1024px) {
  /* lg screens (laptops/desktops) */
  .profile-section {
    margin-top: 60rem;
  }
}

@media (min-width: 1280px) {
  /* xl screens (large desktops) */
  .profile-section {
    margin-top: 21rem;
  }
}
/* Smooth scrollbar for overflow sections */
section::-webkit-scrollbar {
  width: 8px;
}
section::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
}
</style>
